(() => {
  const bindLocalizationForms = (scope = document) => {
    scope.querySelectorAll('.shopify-localization-form').forEach((form) => {
      if (form.dataset.localizationBound === 'true') return;
      form.dataset.localizationBound = 'true';
      form.querySelectorAll('[data-localization-select]').forEach((select) => {
        select.addEventListener('change', () => form.requestSubmit());
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindLocalizationForms());
  else bindLocalizationForms();

  document.addEventListener('shopify:section:load', (event) => bindLocalizationForms(event.target));
})();
